module.exports = __webpack_public_path__ + "static/media/24UHCHR19.50c703fd.jpg";